import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getRewardsList } from '../../api/rewards';
import asusGladiusImg from '../../static/img/Rewards/gladius3.png';
import asusRogDeltaSCoreImg from '../../static/img/Rewards/AsusROGDeltaSCoreGamingHeadphone.avif';
import roxRewHeadphone from '../../static/img/RoxESL/RoxRewHeadphone.png';
import roxRewKeyboard from '../../static/img/RoxESL/RoxRewKeyboard.png';
import roxRewPS5 from '../../static/img/RoxESL/RoxRewPS5.png';
import styles from "../../static/styles/RoxESL/RoxLanding.module.css";

const fallbackPremiumRewards = [
    { id: 'ps5', brand: 'SONY', name: 'PLAYSTATION 5', credits: 60000, image: roxRewPS5, tone: 'blue' },
    { id: 'keyboard', brand: 'ASUS', name: 'TUF K3 RD', credits: 60000, image: roxRewKeyboard, tone: 'red' },
    { id: 'headset', brand: 'EDIFIER', name: 'G2', credits: 60000, image: roxRewHeadphone, tone: 'green' },
    { id: 'mouse', brand: 'ASUS', name: 'GLADIUS III P514', credits: 60000, image: asusGladiusImg, tone: 'gold' },
];

const getRewardImage = (rewardName) => {
    if (!rewardName) return '';
    const name = rewardName.toLowerCase();
    if (name.includes('playstation')) return roxRewPS5;
    if (name.includes('asus rog') && name.includes('headphone')) return asusRogDeltaSCoreImg;
    if (name.includes('edifier')) return roxRewHeadphone;
    if (name.includes('asus') && name.includes('keyboard')) return roxRewKeyboard;
    if (name.includes('bloody')) return roxRewKeyboard;
    if (name.includes('asus rog') && name.includes('mouse')) return asusGladiusImg;
    return '';
};

const getRewardBrand = (rewardName) => {
    const name = rewardName?.toLowerCase() || '';
    if (name.includes('playstation')) return 'SONY';
    if (name.includes('edifier')) return 'EDIFIER';
    if (name.includes('asus')) return 'ASUS';
    if (name.includes('bloody')) return 'BLOODY';
    return '';
};

const getRewardTone = (rewardName, index) => {
    const name = rewardName?.toLowerCase() || '';
    if (name.includes('playstation')) return 'blue';
    if (name.includes('keyboard') || name.includes('bloody')) return 'red';
    if (name.includes('head')) return 'green';
    if (name.includes('mouse')) return 'gold';
    return ['blue', 'red', 'green', 'gold'][index % 4];
};

const RoxRewardsSlide = () => {
    const navigate = useNavigate();
    const [premiumRewards, setPremiumRewards] = useState(fallbackPremiumRewards);

    useEffect(() => {
        let isMounted = true;

        const loadPremiumRewards = async () => {
            try {
                const response = await getRewardsList();
                const rewardsData = response?.data;

                if (!isMounted || !Array.isArray(rewardsData)) return;

                const premiumData = rewardsData
                    .filter((reward) => reward.game === null)
                    .slice(0, 4)
                    .map((reward, index) => ({
                        id: reward.id || reward.name,
                        brand: getRewardBrand(reward.name),
                        name: reward.name,
                        credits: reward.credits,
                        image: getRewardImage(reward.name),
                        tone: getRewardTone(reward.name, index),
                    }));

                if (premiumData.length > 0) {
                    setPremiumRewards(premiumData);
                }
            } catch (error) {
                if (!isMounted) return;
                setPremiumRewards(fallbackPremiumRewards);
            }
        };

        loadPremiumRewards();

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <div className={styles.RoxSlide}>
            <span className={styles.RoxRewardsBadge}>★ VIP ACCESS UNLOCKED ★</span>
            <span className={styles.RoxRewardsTitle}>EXCLUSIVE REWARDS SHOP</span>
            <p className={styles.RoxRewardsMsg}>Items only Premium members can claim</p>

            <div className={styles.RoxRewardsGrid}>
                {premiumRewards.map((reward) => (
                    <div
                        className={`${styles.RoxRewardCard} ${styles[`RoxRewardCard${reward.tone}`]}`}
                        key={reward.id}
                    >
                        <div className={styles.RoxRewardImageBox}>
                            {reward.image && <img src={reward.image} alt="" />}
                        </div>
                        <span className={styles.RoxRewardBrand}>{reward.brand}</span>
                        <strong>{reward.name}</strong>
                        <span className={styles.RoxRewardPrice}>
                            <span aria-hidden="true" />
                            {reward.credits?.toLocaleString() || '60,000'}
                        </span>
                    </div>
                ))}
            </div>

            <button className={styles.RoxVipShopLink} type="button" onClick={() => navigate('/rewards')}>
                SEE FULL VIP SHOP <span aria-hidden="true">-&gt;</span>
            </button>
        </div>
    );
};

export default RoxRewardsSlide;
